// ── 매입 업로드 이력 창 (2026-11-03 사용자: [📤 업로드 ▾] → 🕘 이력보기) ──────────────────────
// 예전 화면 아래 '업로드 이력' 표(UploadSection)를 그대로 옮겼다 — 파일 업로드·붙여넣기 묶음이 한 표에(붙여넣기는 이름 "붙여넣기 날짜").
// 줄마다 [CSV](그 묶음 원본 내려받기) · [삭제](묶음 되돌리기 — 묻는 창은 useCashflowPurchase.rollback). 창 안에서는 다 보인다(접기 없음).
// 맨 위 안내 글도 예전 화면에서 옮김.
import React from 'react';
import Modal from '../../../components/Modal';
import { toDateTimeString } from '../../../utils/date';
import { stdOutlineBtn, stdTableWrap, stdTable, stdTh, stdTd, stdCell } from '../adminlayout/designStandard';

function downloadBatchCsv(companyCode, batchId, fileName) {
  const token = localStorage.getItem('accessToken') || '';
  fetch(`/api/admin/cashflow/purchases/batch/${batchId}/download?company_code=${companyCode}`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then(async (r) => {
    if (!r.ok) {
      const j = await r.json().catch(() => ({}));
      alert(j.message || '다운로드 실패');
      return;
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = (fileName || `purchase_batch_${batchId}`).replace(/\.(xlsx?|csv)$/i, '') + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}

const HEADS = ['업로드일시', '파일명', '전체', '신규', '스킵/갱신', '업로더', ''];

export default function BatchHistoryModal({ open, title, companyCode, batches, onRollback, onClose }) {
  return (
    <Modal
      open={open}
      icon="🕘"
      title={title}
      onClose={onClose}
      width="min(920px, calc(100vw - 32px))"
      footer={<div style={{ display: 'flex', justifyContent: 'flex-end' }}><button style={stdOutlineBtn} onClick={onClose}>닫기</button></div>}
    >
      <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 10, lineHeight: 1.6 }}>
        raw 은행자료 또는 정리된 8컬럼 자료(엑셀·붙여넣기) 모두 인식. 정리본은 같은 거래(구분+사용일+업체+금액)면 비고·세금계산서·발급일을 덮어써 갱신하고, 없으면 추가합니다.
      </div>
      <div style={{ ...stdTableWrap, overflowX: 'auto' }}>
        <table style={{ ...stdTable, minWidth: 640 }}>
          <thead>
            <tr>{HEADS.map((h) => <th key={h} style={stdTh}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {batches.length === 0 && (
              <tr>
                <td colSpan={HEADS.length} style={{ ...stdTd, borderBottom: 'none', textAlign: 'center', color: 'var(--text-muted)', padding: 20 }}>
                  업로드 이력이 없습니다.
                </td>
              </tr>
            )}
            {batches.map((b, i) => {
              const cell = stdCell(i, batches.length);
              return (
                <tr key={b.id}>
                  {/* uploaded_at 은 TIMESTAMPTZ(UTC 글자로 옴) → 한국 시간 'YYYY-MM-DD HH:mm' (2026-10-08) */}
                  <td style={{ ...cell, whiteSpace: 'nowrap' }}>{b.uploaded_at ? toDateTimeString(b.uploaded_at).slice(0, 16) : '-'}</td>
                  <td style={cell}>{b.file_name || '-'}</td>
                  <td style={{ ...cell, textAlign: 'center' }}>{b.row_count}</td>
                  <td style={{ ...cell, textAlign: 'center', color: '#15803d' }}>{b.inserted_count}</td>
                  <td style={{ ...cell, textAlign: 'center', color: 'var(--text-muted)' }}>{b.skipped_count}</td>
                  <td style={cell}>{b.uploaded_by_name || '-'}</td>
                  <td style={{ ...cell, whiteSpace: 'nowrap', textAlign: 'right' }}>
                    <div style={rowBtnGroup}>
                      <button style={rowBtn} onClick={() => downloadBatchCsv(companyCode, b.id, b.file_name)}>CSV</button>
                      <button style={rowBtnMuted} onClick={() => onRollback(b.id)}>삭제</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}

// 표 행 안 액션 버튼 — 직원 관리 표(tableActionBtn) 톤: 작은 중립 외곽선/muted
const rowBtn = { fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text)', cursor: 'pointer' };
const rowBtnMuted = { ...rowBtn, background: 'var(--bg-subtle)', color: 'var(--text-sub)' };
const rowBtnGroup = { display: 'flex', gap: 4, justifyContent: 'flex-end' };
